import { render, staticRenderFns } from "./HeaderNav.vue?vue&type=template&id=34597070&"
import script from "./HeaderNav.vue?vue&type=script&lang=js&"
export * from "./HeaderNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports